import Header from '../../Shared/Header/Header';

const title = 'Abertura de Chamados';
const subtitle =
  'Solução integrada para abertura e acompanhamento de chamados na plataforma';

export default function ServiceRequestsHeader() {
  return <Header title={title} subtitle={subtitle} />;
}
